module.exports = __webpack_public_path__ + "img/dimension.97ad8615.svg";